












import Country from '@/locations/models/country'
import countriesService from '@/locations/services/countries-service'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import sortBy from 'lodash/sortBy'

@Component
export default class CountrySelect extends Vue {
  @Prop({ default: 'AT' })
  private value!: string

  private items: Country[] = []
  private country: string = this.value

  @Watch('value')
  private valueChanged(val: string, old: string) {
    if (val !== old) {
      this.country = val
    }
  }

  @Watch('country')
  private countryChanged(val: Country, old: Country) {
    this.$emit('input', val)
  }

  private async loadAllAsync() {
    const items = []
    for (const code of await countriesService.loadAllAsync()) {
      const country = new Country()
      country.code = code
      country.name = this.$tc(`locations.countries.${code}`)
      items.push(country)
    }
    this.items = sortBy(items, 'name')
  }

  private async mounted() {
    await this.loadAllAsync()
    this.country = this.value
  }
}
